import axios from "axios";
import router from "@/router/index";
import { uuid } from "@/utils/common";
import { Message } from "element-ui";
import { onlineUrl, loginUrl, passportUrl } from "@/utils/config";
import Store from "@/store";
const instance = axios.create({
  baseURL: onlineUrl,
  withCredentials: true,
});

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 头像下拉框相关接口
    // if (config.url.indexOf("account") !== -1) {
    //   config.url = config.url.replace("account", "");
    //   config.baseURL = passportUrl;
    // }
    config.headers = {
      ...config.headers,
      "X-Haizol-Reqid": `${uuid()}`,
      "orig-prj": "haizol-saas-console-supplier",
    };
    // 配置代理 api那边以/need/...开头就可以
    // if(/^\/.*/.test(config.url) && !config.url.includes('/need/')) {
    //   config.baseURL = onlineUrl;
    //   config.url = onlineUrl + config.url;
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    if (response.data.rspResult) {
      if (response.data.rspResult.bizCode === 401) {
        const href = `${loginUrl}/pst/login?returnURL=${window.location.href}`;
        window.location.href = href;
      } else if (
        response.data.rspResult.bizCode === 403 ||
        response.data.rspResult.bizCode === 1000
      ) {
        Store.commit("SET_PERMISSION", false);
        router.replace({
          name: "403",
        });
      }

      // 当状态码不为200时，默认弹出错误提示框，如果有特殊业务不需要弹出，可以在接口的config加 noMessage: true
      const rspResult = response.data?.rspResult || {};
      if (
        rspResult.bizCode &&
        rspResult.bizCode !== 200 &&
        !response.config?.noMessage &&rspResult.bizCode !==404&&rspResult.bizCode !==14000&&rspResult.bizCode !==1206
      ) {
        if (rspResult?.message)
          Message.closeAll()
          Message({
            type: "error",
            message: rspResult.message,
            duration: 2000,
          });
      }
    }

    if (!response.data.rspResult && typeof response.data.code === "number") {
      if (response.data.code === 401) {
        const href = `${loginUrl}/pst/login?returnURL=${window.location.href}`;
        window.location.href = href;
      } else if (response.data.code === 403) {
        Store.commit("SET_PERMISSION", false);
        router.replace({
          name: "403",
        });
      }

      if (response.data.code !== 200 && !response.config?.noMessage) {
        Message.closeAll()
        Message({
          type: "error",
          message: response.data.msg || "操作失败",
          duration: 2000,
        });
      }
    }
    return response.data;
  },
  (error) => {
    if (error && error.code && error.code !== "ECONNABORTED") {
      Message.error("系统异常");
      if (error.response) {
        switch (error.response.status) {
          case 401:
          // 返回 401 清除token信息并跳转到登录页面
          // router.replace({
          //     path: 'login',
          //     query: {redirect: router.currentRoute.fullPath}
          // })
        }
        return Promise.reject(error.response.data); // 返回接口返回的错误信息
      }
      return Promise.reject(error);
    }
    return Promise.reject("haizol-request-cancel");
  }
);

export default instance;
